import { Alert, AlertTitle } from "@mui/material";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import type { MemberChangeView } from "./membersChangeRequestHelper";

interface Props {
  members: MemberChangeView[];
}

const MemberContactFlagAlert = ({ members }: Props) => {
  const matchedCount = members.filter((member) => member.existingContact).length;
  const newCount = members.length - matchedCount;

  if (matchedCount > 0) {
    return (
      <Alert severity="info">
        <AlertTitle>
          {matchedCount} existing {pluralize("contact", matchedCount)} matched
        </AlertTitle>
        {newCount > 0 ? (
          <>
            Access will be added to {matchedCount} existing {pluralize("record", matchedCount)} matched by email. The
            remaining{" "}
            <strong>
              {newCount} new {pluralize("contact", newCount)}
            </strong>{" "}
            will be created upon approval.
          </>
        ) : (
          <>
            New contacts in this request were matched by email to records already in the system. Access will be added to
            those records — no new contacts will be created.
          </>
        )}
      </Alert>
    );
  }

  const [firstMember] = members;

  return (
    <Alert severity="info">
      <AlertTitle>No existing contact found</AlertTitle>
      {members.length === 1 && firstMember ? (
        <>
          A new contact will be created for{" "}
          <strong>
            {firstMember.name} &lt;{firstMember.email}&gt;
          </strong>{" "}
          upon approval.
        </>
      ) : (
        <>
          <strong>{members.length} new contacts</strong> will be created upon approval.
        </>
      )}
    </Alert>
  );
};

export default MemberContactFlagAlert;
